import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import * as FiIcons from "react-icons/fi";

import SafeIcon from "../../common/SafeIcon";

const { FiCpu } = FiIcons;

export default function FloatingAIButton() {
  const navigate = useNavigate();

  return (
    <motion.button
      type="button"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={() => navigate("/assistant")}
      aria-label="Open ProfitYo AI Assistant"
      className="group fixed bottom-8 right-8 z-50 flex h-14 w-14 items-center justify-center rounded-2xl border border-slate-700/50 bg-slate-900 text-white shadow-2xl"
    >
      <SafeIcon
        icon={FiCpu}
        className="text-2xl transition-colors group-hover:text-emerald-400"
      />

      <div className="absolute -right-1 -top-1 h-3 w-3 animate-pulse rounded-full border-2 border-white bg-emerald-500" />
    </motion.button>
  );
}